import styled from 'styled-components';
import title from '../images/Interactive.svg';
import { mediaQueries } from '../shared/config'

const BG1 = styled('div')`
    background-color: #0864BB;
    height: 798px;
    border-color: #0864BB;
    border-top-style: solid;
    border-bottom-style: none;
    position: relative;
    text-align: center;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: relative;
`;

const ImageContainer = styled.div`
    background-color: #0864BB;
    width: 100%;
    z-index: -1;
    object-fit: fill;
    ${mediaQueries.mobile}{
        border-width: 12px;
    }
`;

const StyledImage = styled.img`
    width: 80%; // Make image fill the container width
    height: auto; // Maintain aspect ratio
    object-fit: cover; // Cover the area, may crop the image
`;


const Title = styled.img`
    width: 50%;
    position: relative;
    margin-bottom: 20vh;
    margin-top: 20vh;
    z-index: 5; 
    top: 15px;
    ${mediaQueries.mobile}{
        top: 10px;
        width: 250px;
    }
`;

const Credits = styled.div`
  font-family: Fjalla One;
  border: none;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-align: right;
  padding-right: 15px;
  padding-bottom: 15px;
  color: #010c39;
  background-color: #0864BB;
  height: 30px;
  ${mediaQueries.mobile} {
    font-size: 8px;
  }
`;

const Interactive = (props) => {
    return (
        <>
            <ImageContainer>
                <Title src={title} />
            </ImageContainer>
            <BG1>
                <iframe
                    src="https://wp.dailybruin.com/wp-content/themes/caeruleum/js/interactives/sports.gymnastics.2024/quiz/gymQuiz"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}  // Correct way to apply styles in JSX
                ></iframe>
            </BG1>
            <Credits> Liam McGlynn, Assistant Data editor </Credits>
        </>

    );
};

export default Interactive;